<template>
  <div>
    <div id="content" class="content" style="margin-left:0px;">
      <h1 class="page-header" style="text-align:left">
        保证金管理
        <small>/&nbsp;保证金管理列表</small>
      </h1>

      <div
        id="page-container"
        class="in page-sidebar-fixed page-header-fixed"
        style="padding-top:0px;"
      >
        <!-- begin #content -->
        <div
          id="content"
          class="content"
          style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
        >
          <!-- begin breadcrumb -->

          <div class="row">
            <!-- begin col-10 -->
            <div class="col-lg-12">
              <!-- begin panel -->
              <div class="panel panel-inverse">
                <!-- begin panel-heading -->
                <div class="panel-heading">
                  <div class="panel-heading-btn">
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-default"
                      data-click="panel-expand"
                    >
                      <i class="fa fa-expand"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-success"
                      data-click="panel-reload"
                    >
                      <i class="fa fa-redo"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-warning"
                      data-click="panel-collapse"
                    >
                      <i class="fa fa-minus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-danger"
                      data-click="panel-remove"
                    >
                      <i class="fa fa-times"></i>
                    </a>
                  </div>
                  <h4 class="panel-title panelTitle">保证金管理列表</h4>
                </div>
                <!-- end panel-heading -->
                <!-- begin panel-body -->
                <div class="panel-body">
                 <form style="margin-top:16px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">合同编号</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="合同编号"
                          v-model="contractNo"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">合同标题</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="合同标题"
                          v-model="contractTitle"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">保证金缴纳时间</label>
                        <div class="col-md-3">
                          <el-date-picker
                            style="width:100%;height:34px;"
                            v-model="TimeValue"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="ChangePicker"
                          ></el-date-picker>
                        </div>
                      <div class="col-md-2"></div>
                      <label class="col-md-1 col-form-label LineSpacing">服务商名称</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="recomId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="服务商名称"
                        >
                          <el-option
                            v-for="item in recomList"
                            :key="item.recomId"
                            :label="item.recomName"
                            :value="item.recomId"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="col-md-1 LineSpacing">
                        <a
                          class="btn btn-primary ButtonColor m-r-5"
                          @click="SearchClick()"
                        >查询</a>
                      </div>

                      <div class="col-md-8"></div>
                      <div class="col-md-11"></div>
                       <div class="col-md-1">
                        <a class="btn btn-primary ButtonColor m-r-5" @click="AddClick()">新增</a>
                      </div>
                    </div>
                  </fieldset>
                </form>


                  <el-table :data="contractList" border style="width: 100%">
                    <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column prop="contractNo" label="合同编号" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="contractTitle" label="合同标题" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="city" label="合同区域" align="center" show-overflow-tooltip></el-table-column>
<!--                    <el-table-column label="合同品类" align="center" show-overflow-tooltip>-->
<!--                      <template slot-scope="scope">-->
<!--                        <el-popover trigger="hover">-->
<!--                          <p v-for="(item,index) in scope.row.goodsNameList" :key="index">{{item}}</p>-->
<!--                          <div slot="reference" class="name-wrapper SkuHover">-->
<!--                            <span>{{ scope.row.goodsNameList[0] }} &nbsp;<b  v-if=" scope.row.goodsNameList.length  > 1 ">...</b></span>-->
<!--                          </div>-->
<!--                        </el-popover>-->
<!--                      </template>-->
<!--                    </el-table-column>-->
                    <!-- <el-table-column prop="contractTerm" label="合同期限" align="center" show-overflow-tooltip></el-table-column> -->
                    <el-table-column prop="recomName" label="分销商" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="clientSignTime" label="合同签订日期" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="contractTerm" label="合同截止日期" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="deposit" label="保证金(元)" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="depositTime" label="保证金缴纳时间" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="depositStatusName" label="状态" align="center" show-overflow-tooltip></el-table-column>
<!--                    <el-table-column label="凭证" align="center" show-overflow-tooltip>-->
<!--                      <template slot-scope="scope">-->
<!--                        <img :src="scope.row.fileUrl" alt="" v-if="scope.row.fileUrl" @click="EnlargeImg(scope.row)" class="LogoImg">-->
<!--                      </template>-->
<!--                    </el-table-column>-->
                    <el-table-column label="操作" width="200" align="center">
                      <template slot-scope="scope">
                        <el-button
                          class="btn btn-primary btn-sm ButtonColor"
                          size="small"
                          @click="EditClick(scope.row)"
                          >编辑
                        </el-button>
                        <el-button
                          class="btn btn-warning btn-sm ButtonColor"
                          size="small"
                          @click="DeleteClick(scope.row)"
                          >删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="PaginationStyle">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="pageindex"
                      :page-sizes="[10,20,50,100]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      background
                      :total="totalCount"
                    ></el-pagination>
                  </div>
                </div>
                <!-- end panel-body -->
              </div>
              <!-- end panel -->
            </div>
            <!-- end col-10 -->
          </div>
          <!-- end row -->
        </div>
        <!-- end #content -->
      </div>
      <el-dialog title :visible.sync="outerVisible" width="500px" :before-close="handleClose">
        <div v-if="EditDialog === 2" class="ModelPadding">
          <div class="swal-icon swal-icon--info"></div>
          <div class="swal-title">您确定删除吗?</div>
          <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled = 'disabled'>确定</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible = false"
              >取消</div>
            </div>
          </div>
        </div>
        <div v-if="EditDialog === 1" class="ModelPadding">
          <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="150px"
            class="demo-ruleForm"
            style="width:90%"
          >
            <el-form-item label="合同编号" prop="contractNo" :rules="[{ required: true, message: '请选择合同编号', trigger:'blur'}]">
              <el-select v-model="ruleForm.contractNo" placeholder="请选择" :disabled="isEdit" style="width:100%" @change="getRecom">
                <el-option
                  v-for="item in contractNoList"
                  :key="item.contractNo"
                  :label="item.contractNo"
                  :value="item.contractNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同标题" prop="contractNo" :rules="[{ required: true, message: '请选择合同标题', trigger:'blur'}]">
              <el-select v-model="ruleForm.contractNo" placeholder="请选择" :disabled="isEdit" style="width:100%" @change="getRecom">
                <el-option
                  v-for="item in contractNoList"
                  :key="item.contractNo"
                  :label="item.contractTitle"
                  :value="item.contractNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务商" prop="recomName" :rules="[{ required: true, message: '请选择服务商', trigger:'blur'}]">
              <el-input v-model="ruleForm.recomName" placeholder="服务商" disabled></el-input>
            </el-form-item>
            <el-form-item label="交纳保证金数额" prop="deposit"
              :rules="[
                { required: true, message: '保证金不能为空'},
                { type: 'number', message: '保证金必须为数字值'}
              ]"
            >
              <el-input v-model.number="ruleForm.deposit"></el-input>
            </el-form-item>
            <el-form-item label="交纳时间" prop="depositTime" :rules="[{ required: true, message: '请选择交纳时间'}]">
               <el-date-picker
                  v-model="ruleForm.depositTime"
                  type="datetime"
                  placeholder="日期"
                  @change="ChangeDate"
                  align="center"
                ></el-date-picker>
            </el-form-item>
          </el-form>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--confirm btn btn-primary"
                @click="MakeSureEdit('ruleForm')"
                :disabled="disabled"
              >确定</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible = false"
              >取消</div>
            </div>
          </div>
        </div>
        <div v-if="EditDialog === 3" class="ModelPadding">
          <img :src="CurrentSelection.fileUrl" style="width:400px;">
        </div>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "ContractReviewList",
  data() {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      DialogTitle: '',
      EditDialog: 1,
      CurrentSelection: [],
      disabled: false,
      ruleForm: {},
      rules: {},
      contractList:[],
      contractNo: "",
      contractTitle: "",
      recomId:"",
      TimeValue: "",
      recomList: [],
      contractNoList:[],
      errorTip: false,
      percentage:0,
      percentageShow: false,
      percentagestatus:'exception',
      director:0,
      isEdit: false
    };
  },
  mounted: function() {
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initdata();
    this.getRecomList();
    this.getContractList();
  },
  methods: {
    getRecom(data){
      this.contractNoList.filter(item=>{
        if(item.contractNo == data){
         this.ruleForm.recomName = item.recomName;
         this.ruleForm.recomId = item.recomId;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    AddClick(){
      if(this.$refs['ruleForm']){
        this.$refs['ruleForm'].resetFields();
      }
      this.ruleForm = {};
      this.outerVisible = true;
      this.DialogTitle = "新增";
      this.EditDialog = 1;
      this.isEdit = false;
      this.errorTip = false;
      this.percentageShow = false;
    },
    EditClick(row){
      if(this.$refs['ruleForm']){
        this.$refs['ruleForm'].resetFields();
      }
      this.ruleForm = {};
      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      this.isEdit = true;
      this.errorTip = false;
      this.percentageShow = false;
      this.ruleForm = MethodsBus.cloneRow(row);
    },
    DeleteClick(item){
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    MakeSure() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobDepositController/deleteDeposit",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          depositId: that.CurrentSelection.depositId,
        })
      };
      axios(options).then(function(response) {
        that.outerVisible = false;
        if (response.data.code == 200) {
          that.initdata();
          that.$notify({
            title: "成功",
            message: response.data.message,
            type: "success"
          });
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          that.outerVisible = false;
          http.handleHttpError(error, that);
        });
    },
    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "编辑") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.errorTip = false;
            that.disabled = true;
            const options = {
              url: "/distribution/B2cTobDepositController/editDeposit",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                contractNo: that.ruleForm.contractNo,
                recomId: that.ruleForm.recomId,
                deposit: that.ruleForm.deposit,
                depositTime: that.ruleForm.depositTime,
                fileUrl: that.ruleForm.fileUrl,
                depositId: that.ruleForm.depositId
              })
            };
            axios(options).then((response)=> {
              that.disabled = false;
              if (response.data.code == 200) {
                that.outerVisible = false;
                that.initdata();
                that.$notify({
                  title: "成功",
                  message: response.data.message,
                  type: "success"
                });
              } else {
                that.disabled = false;
                http.handleEorrorCode(response, that);
              }
            })
              .catch((error)=> {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              })
          } else {
            that.outerVisible = true;
            that.disabled = false;
          }
        });
      } else if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "/distribution/B2cTobDepositController/addDeposit",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                contractNo: that.ruleForm.contractNo,
                recomId: that.ruleForm.recomId,
                deposit: that.ruleForm.deposit,
                depositTime: that.ruleForm.depositTime,
                fileUrl: that.ruleForm.fileUrl
              })
            };
            axios(options).then((response)=> {
              that.disabled = false;
              if (response.data.code == 200) {
                that.outerVisible = false;
                that.initdata();
                that.$notify({
                  title: "成功",
                  message: response.data.message,
                  type: "success"
                });
              } else {
                that.disabled = false;
                http.handleEorrorCode(response, that);
              }
            })
              .catch((error)=> {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              })
          } else {
            that.outerVisible = true;
            that.disabled = false;
          }
        });
      }
    },
    initdata() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobDepositController/queryDepositByPage",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({
          contractNo: that.contractNo,
          contractTitle: that.contractTitle,
          recomId: that.recomId,
          startContractTerm: that.startTime,
          endContractTerm: that.endTime,
          depositStatusList:[0,1],
          current: that.pageindex,
          size: that.pageSize,
          director:that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.contractList = response.data.data.records;
          that.totalCount = response.data.data.total;
          for (var i in response.data.data.records) {
            response.data.data.records[i].ordernumber =
              Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
            if (response.data.data.records[i].clientSignTime !== null) {
              response.data.data.records[i].clientSignTime = that.FormatAllDate(response.data.data.records[i].clientSignTime).slice(0,10);
            }else {
              response.data.data.records[i].clientSignTime = "";
            }
            if (response.data.data.records[i].ContractTerm !== null) {
              response.data.data.records[i].ContractTerm = that.FormatAllDate(response.data.data.records[i].ContractTerm).slice(0,10);
            }else {
              response.data.data.records[i].ContractTerm = "";
            }
            if (response.data.data.records[i].depositStatus == 1) {
              response.data.data.records[i].depositStatusName = "待审核";
            } else if (response.data.data.records[i].depositStatus == 0) {
              response.data.data.records[i].depositStatusName = "审核拒绝";
            } else if (response.data.data.records[i].depositStatus == 2) {
              response.data.data.records[i].depositStatusName = "审核通过";
            }else{
              response.data.data.records[i].depositStatusName = "状态异常";
            }
          }
        } else {
          http.handleHttpError(response, that);
        }
      })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    // 获取服务商列表
    getRecomList() {
      let that = this;
      const options = {
        url: "distribution/B2cRecomInfoController/getRecomInfoByCompany",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.recomList = response.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    // 获取合同编号
    getContractList() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobContractController/selectContractList",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.contractNoList = response.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    EnlargeImg(row) {
      this.EditDialog = 3;
      this.outerVisible = true;
      this.CurrentSelection = row;
    },
    ChangePicker() {
      if (this.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
      } else if (this.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    ChangeDate(){
      this.ruleForm.depositTime = this.FormatAllDate(this.ruleForm.depositTime);
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    FormatSpecialDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;

      return currentdate;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth{
  width:202px;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.LogoImg {
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/DepositCash.vue